import React, { Component } from 'react'
import 'worldwindjs'
// import axios from 'axios';
import request from '../../utils/request'
import { osintRequestAddress } from '../config'

/* global WorldWind */
export default class TargetsLayer extends Component{
    state = {
        isTargetsListGot: false
    }

    static targetIcons = [
        "./tent2.png",
    ];

    componentDidMount(){
        if (this.state.isTargetsListGot){
            return
        }  
        // console.log( 'worldwind', new WorldWind,)

        // Create a placemark using the selected marker image
        let attributes = new WorldWind.PlacemarkAttributes(null);
        attributes.imageScale = 0.8;
        attributes.imageOffset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 0.35);
        // attributes.imageColor = WorldWind.Color.WHITE;
        attributes.labelAttributes.offset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 1.0);
        attributes.labelAttributes.color = WorldWind.Color.GREEN;
        attributes.labelAttributes.scale = 2.5;
        attributes.drawLeaderLine = true;
        attributes.leaderLineAttributes.outlineColor = WorldWind.Color.RED;
        attributes.imageSource = TargetsLayer.targetIcons[0];
        
        const token = localStorage.getItem('token')
        // axios.get(`https://www.osintsee.com/base?chnname=all`, {
        //     headers: {
        //         'Authorization': token,
        //     },
        // }).
        request({
            url: `${osintRequestAddress}/base?chnname=all`,
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(
            response => {
                if (response && response.length>0){
                    response.map(
                        (target) => {
                            let position = { latitude: target.lat, longitude: target.lon, altitude: 0 }
                            let placemark = new WorldWind.Placemark(position, /*eyeDistanceScaling*/ true, attributes);
                            placemark.type = 'target'
                            placemark.label = target.chnName;
                            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
                            placemark.eyeDistanceScalingThreshold = 2500000;
                            placemark.eyeDistanceScalingLabelThreshold = 25000000;
                            // Add the placemark to the layer and to the Markers component
                            const globe = this.props.globe;                            
                            const layer = globe.getLayer(this.props.markersLayerName);
                            if (layer) {
                                // Add the placemark to the globe
                                layer.addRenderable(placemark);  
                                // send the placemark to the Markers component                            
                                this.props.addTarget(placemark, target)
                            } else {
                                console.warn("Renderable layer for markers not found: "+ this.props.markersLayerName);
                            }

                            return ""  
                        }   
                                         
                    )                   
                    this.setState({isTargetsListGot:true})
                }
            },
            error => {console.log("error",error)}
        )
    } 
    render(){
        return <div></div>
    }
}
